import React from 'react';
import { PhoneIcon } from 'lucide-react';
interface ServiceCTABannerProps {
  headline: string;
}
export function ServiceCTABanner({
  headline
}: ServiceCTABannerProps) {
  return <section className="w-full py-20 px-4 relative overflow-hidden" style={{
    backgroundColor: '#0283C7'
  }} data-id="element-631">
      <div className="absolute inset-0 pointer-events-none" style={{
      opacity: 0.06
    }} data-id="element-632">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-633">
          <defs data-id="element-634">
            <pattern id="cta-grid" x="0" y="0" width="60" height="60" patternUnits="userSpaceOnUse" data-id="element-635">
              <path d="M 60 0 L 0 0 0 60" fill="none" stroke="white" strokeWidth="1" data-id="element-636" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#cta-grid)" data-id="element-637" />
        </svg>
      </div>
      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-638">
        <h2 className="font-bold text-white mb-4" style={{
        fontFamily: 'Montserrat, sans-serif',
        fontSize: 'clamp(28px, 5vw, 36px)',
        fontWeight: 900,
        lineHeight: 1.1
      }} data-id="element-639">
          {headline}
        </h2>
        <p className="mb-10" style={{
        color: 'rgba(255,255,255,0.85)',
        fontFamily: 'Inter, sans-serif',
        fontSize: '18px',
        lineHeight: 1.6
      }} data-id="element-640">
          Get your free, no-obligation quote today. Licensed, bonded, and
          insured.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-641">
          <a href="#quote" className="font-bold text-center py-4 px-10 rounded-lg transition-all hover:scale-[1.03] min-h-[54px] flex items-center justify-center" style={{
          backgroundColor: '#ffffff',
          color: '#0283C7',
          fontFamily: 'Inter, sans-serif',
          fontSize: '17px',
          borderRadius: '8px',
          boxShadow: '0 4px 16px rgba(0,0,0,0.15)'
        }} data-id="element-642">
            Get a Free Quote
          </a>
          <a href="tel:4805998442" className="font-bold text-white text-center py-4 px-10 rounded-lg border-2 transition-all hover:bg-white hover:text-blue-600 min-h-[54px] flex items-center justify-center gap-2" style={{
          borderColor: '#ffffff',
          fontFamily: 'Inter, sans-serif',
          fontSize: '17px',
          borderRadius: '8px'
        }} data-id="element-643">
            <PhoneIcon className="h-5 w-5" data-id="element-644" />
            Call Now: (480) 599-8442
          </a>
        </div>
      </div>
    </section>;
}